import React from 'react';
function DownloadCloud({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 18l4 3 4-3M12 13v8M18.867 17.231a4.09 4.09 0 00-1.955-7.682h-1.03A6.545 6.545 0 104.64 15.522"
      />
    </svg>
  );
}

export default DownloadCloud;
